var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "estate-content" }, [
    _vm.estate.description
      ? _c(
          "div",
          { staticClass: "row border-radius bg-white padding-flex mb-1" },
          [
            _c(
              "div",
              { staticClass: "col-md-12 estate-description" },
              [
                _c(
                  "h2",
                  [
                    _c("masked-image", {
                      staticClass: "icon_title",
                      attrs: { src: "/img/icons/description.svg" }
                    }),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("capitalize")(_vm.trans("labels.description"))
                        ) +
                        "\n            "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "estate-description-container" },
                  [_vm._t("description")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "modal",
                  {
                    ref: "description",
                    attrs: {
                      name: "description",
                      "extra-class": "full-screen-modal description-modal",
                      title: _vm._f("capitalize")(
                        _vm.trans("labels.description")
                      ),
                      icon: "description.svg"
                    }
                  },
                  [
                    _c("template", { slot: "body" }, [
                      _c("div", { staticClass: "open-sign text-left" }, [
                        _c("img", {
                          staticClass: "dec",
                          attrs: { src: "/img/icons/edit-descr.svg" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "px-2",
                        domProps: { innerHTML: _vm._s(_vm.estate.description) }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "close-sign text-right" }, [
                        _c("img", {
                          staticClass: "dec",
                          attrs: { src: "/img/icons/edit-descr.svg" }
                        })
                      ])
                    ])
                  ],
                  2
                )
              ],
              1
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row border-radius bg-white padding-flex mb-1" }, [
      _c(
        "div",
        { staticClass: "col-md-12 estate-features" },
        [
          _c(
            "h2",
            [
              _c("masked-image", {
                staticClass: "icon_title",
                attrs: { src: "/img/icons/features.svg" }
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("capitalize")(_vm.trans("labels.features"))) +
                  "\n            "
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.firstFeatures, function(value, feature) {
            return [
              feature
                ? _c("div", { key: feature, staticClass: "row" }, [
                    _c("div", { staticClass: "col estate-features-title" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm.trans("features." + feature)
                            )
                          ) + ":"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col estate-features-value" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(value) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm.featuresCount > _vm.features_count
            ? _c(
                "modal-opener",
                { staticClass: "features", attrs: { name: "features" } },
                [
                  _c("button", { staticClass: "btn btn-text" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("labels.show_more")) +
                        "\n                "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "modal",
            {
              ref: "features",
              attrs: {
                name: "features",
                "extra-class": "full-screen-modal features-modal",
                title: _vm._f("capitalize")(_vm.trans("labels.features")),
                icon: "features.svg"
              }
            },
            [_c("template", { slot: "body" }, [_vm._t("features")], 2)],
            2
          ),
          _vm._v(
            "\n\n            " + _vm._s(_vm.trans("labels.info")) + "\n        "
          )
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.costs
        ? _c("div", { staticClass: "costs-box col-xl-6 col-auto pl-0 " }, [
            _c(
              "div",
              { staticClass: "estate-costs" },
              [
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm._f("capitalize")(_vm.trans("labels.costs")))
                  )
                ]),
                _vm._v(" "),
                _c("show-more", [_vm._t("costs")], 2),
                _vm._v(" "),
                _vm.showCalculateMortgage
                  ? _c(
                      "div",
                      { staticClass: "row buttons" },
                      [
                        _vm.config_estate.custom_offer
                          ? _c(
                              "modal-opener",
                              { attrs: { name: "custom-offer" } },
                              [
                                _c(
                                  "button",
                                  { staticClass: "btn" },
                                  [
                                    _c("masked-image", {
                                      attrs: {
                                        src: "/img/icons/price-proposal.svg"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.trans("labels.custom_offer")
                                        ) +
                                        "\n                        "
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "modal-opener",
                          {
                            staticClass: "calculate-mortgage",
                            attrs: { name: "calculate-mortgage" }
                          },
                          [
                            _c(
                              "button",
                              { staticClass: "btn" },
                              [
                                _c("masked-image", {
                                  attrs: { src: "/img/icons/calculate.svg" }
                                }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.trans("labels.calculate_mortgage")
                                    ) +
                                    "\n                        "
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xl-12 col-auto w-100" },
        [_c("energy-data", { attrs: { estate: _vm.estate, version: 2 } })],
        1
      )
    ]),
    _vm._v(" "),
    _vm.estate.points_of_interest
      ? _c(
          "div",
          { staticClass: "row border-radius bg-white padding-flex mb-1" },
          [
            _c("div", { staticClass: "col-md-12 p-0" }, [
              _c(
                "div",
                { staticClass: "estate-points-of-interest" },
                [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm.trans("labels.points_of_interest")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "points-of-interest-container mt-1" },
                    [
                      _c("points-of-interest-list", {
                        attrs: { poi: _vm.estate.points_of_interest }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "modal-opener",
                    {
                      staticClass: "points-of-interest",
                      attrs: { name: "points-of-interest" }
                    },
                    [
                      _c("button", { staticClass: "btn btn-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.trans("labels.show_more")) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "modal",
                    {
                      ref: "points-of-interest",
                      attrs: {
                        name: "points-of-interest",
                        "extra-class":
                          "full-screen-modal points-of-interest-modal",
                        title: _vm._f("capitalize")(
                          _vm.trans("labels.points_of_interest")
                        )
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "body" },
                        [
                          _c("points-of-interest-list", {
                            attrs: { poi: _vm.estate.points_of_interest }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }